import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import EnquiryModal from "./components/EnquiryModal";
import Home from "./pages/Home";
import Industries from "./pages/Industries";
import IndustryPage from "./pages/IndustryPage";
import About from "./pages/About";
import Contact from "./pages/Contact";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const [enquiry, setEnquiry] = useState({ open: false, product: "", size: "" });
  const openEnquire = (product = "", size = "") => setEnquiry({ open: true, product, size });
  const setOpen = (open) => setEnquiry((e) => ({ ...e, open }));

  // Disable right-click on images site-wide to prevent copying
  useEffect(() => {
    const blockImageContextMenu = (e) => {
      if (e.target && e.target.tagName === "IMG") e.preventDefault();
    };
    document.addEventListener("contextmenu", blockImageContextMenu);
    return () => document.removeEventListener("contextmenu", blockImageContextMenu);
  }, []);

  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ScrollToTop />
        <Header onEnquire={() => openEnquire()} />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home onEnquire={openEnquire} />} />
            <Route path="/industries" element={<Industries onEnquire={() => openEnquire()} />} />
            <Route path="/industries/:slug" element={<IndustryPage onEnquire={openEnquire} />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home onEnquire={openEnquire} />} />
          </Routes>
        </main>
        <Footer />
        <EnquiryModal open={enquiry.open} onOpenChange={setOpen} defaultProduct={enquiry.product} defaultSize={enquiry.size} />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
